import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
	Box,
	LazyImage,
	SpanStyled,
} from "../../ui/Elements";
import { FooterLogoAr, FooterLogoEn, Logo, LogoAr, MinistryLogo1, MinistryLogo2, Vision2030 } from "../../ui/AllImages";
import { Link } from "react-router-dom";
import { NavDataConfig } from "../../ui/includes/HeaderData";



const Footer = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();
	const date_year = new Date();
	const FowlUrl = () => {
		const whatsappURL = "https://fowl.sa/home";
		window.open(whatsappURL, "_blank");
	};
	const FowlWeb = () => {
		window.open("https://websites.fowl.sa/", "_blank");
	};
	return (
		<FooterWrapper className="container-fluid footerWrapper" lang={language}>
			<Box className="footerCrWrapper">
				<Container className="footerContain2">
					<Row className="footer-row align-items-center justify-content-center justify-content-sm-between">
						<Box className="footerLogo mt-2">
							{language === "ar" ? (
								<Logo />
							) : (
								<Logo />
							)}
						</Box>
						<Box className='d-flex flex-column justify-content-center align-items-center fListMain'>
                            
                            <Box className='text-center copyright mb-2'>
                                <SpanStyled
									className="footer-op"
									size="16px"
									color="var(--bg2)"
									transform="capitalize"
								>
									{t("Copyright")} &copy; <span className="engReg">{date_year.getFullYear()}</span>
									<SpanStyled
										className="footer-op footer-op-company"
										size="16px"
										color="var(--bg2)"
										family="var(--familyRbtFlex)"
										weight="var(--bold)"
									>
										&nbsp;<b>{t("HISASREALESTATE")}</b>.
									</SpanStyled>
								</SpanStyled>
								<SpanStyled
									className="footer-op footer-op-allRights"
									size="16px"
									color="var(--bg2)"
									transform="capitalize"
								>
									&nbsp;{t("AllRightReserved2")}
								</SpanStyled>
                            </Box>
							<Box className='footer-list'>
                                {NavDataConfig.map((item, key) => (
                                    <Box key={key} className='footer-nav-items d-flex gap-2'>
                                        <Link to={item.to} spy={true} smooth={true} offset={-60} duration={500}>{t(item.label)}</Link>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
						
						<Box className="exFoot">
							<Link to="#!"><LazyImage src={Vision2030} /></Link>
							
						</Box>

					</Row>
				</Container>
			</Box>
		</FooterWrapper>
	);
};

export default Footer;
